module.exports = __webpack_public_path__ + "static/media/loginBg.be913c14.png";